"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostQueryRequest = instanceOfApiPostQueryRequest;
exports.ApiPostQueryRequestFromJSON = ApiPostQueryRequestFromJSON;
exports.ApiPostQueryRequestFromJSONTyped = ApiPostQueryRequestFromJSONTyped;
exports.ApiPostQueryRequestToJSON = ApiPostQueryRequestToJSON;
exports.ApiPostQueryRequestToJSONTyped = ApiPostQueryRequestToJSONTyped;
const ApiPostQueryRequestData_1 = require("./ApiPostQueryRequestData");
const ApiPostQueryRequestScale_1 = require("./ApiPostQueryRequestScale");
/**
 * Check if a given object implements the ApiPostQueryRequest interface.
 */
function instanceOfApiPostQueryRequest(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('tableName' in value) || value['tableName'] === undefined)
        return false;
    return true;
}
function ApiPostQueryRequestFromJSON(json) {
    return ApiPostQueryRequestFromJSONTyped(json, false);
}
function ApiPostQueryRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'filter': json['filter'] == null ? undefined : json['filter'],
        'evol': json['evol'] == null ? undefined : json['evol'],
        'scale': json['scale'] == null ? undefined : (0, ApiPostQueryRequestScale_1.ApiPostQueryRequestScaleFromJSON)(json['scale']),
        'data': (0, ApiPostQueryRequestData_1.ApiPostQueryRequestDataFromJSON)(json['data']),
        'order': json['order'] == null ? undefined : json['order'],
        'total': json['total'] == null ? undefined : json['total'],
        'count': json['count'] == null ? undefined : json['count'],
        'tableName': json['table_name'],
        'databaseName': json['database_name'] == null ? undefined : json['database_name'],
    };
}
function ApiPostQueryRequestToJSON(json) {
    return ApiPostQueryRequestToJSONTyped(json, false);
}
function ApiPostQueryRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'filter': value['filter'],
        'evol': value['evol'],
        'scale': (0, ApiPostQueryRequestScale_1.ApiPostQueryRequestScaleToJSON)(value['scale']),
        'data': (0, ApiPostQueryRequestData_1.ApiPostQueryRequestDataToJSON)(value['data']),
        'order': value['order'],
        'total': value['total'],
        'count': value['count'],
        'table_name': value['tableName'],
        'database_name': value['databaseName'],
    };
}
